import * as React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {StartIconsWrapper} from '@vio/atlas/helpers/InputBase'
import {
  InputButton,
  InputButtonStyledContainer
} from '@vio/atlas/helpers/InputButton'
import {Icon} from '@vio/atlas/Icon'
import {truncateSingleLine} from '@vio/atlas/src/utils/truncate'
import {cssTheme} from '@vio/atlas/themes'

interface Props {
  /** Date to be displayed in the FakeInput */
  value: string
  /** The click handler */
  onClick: () => void
  /** Error flag */
  hasError?: boolean
}

const destinationPickerMessages = defineMessages({
  destinationPlaceholder: {
    id: 'whereAreYouGoing',
    defaultMessage: 'Where are you going?'
  }
})

const Wrapper = styled.div`
  position: relative;
`

const DestinationValue = styled.div`
  ${truncateSingleLine()}
  margin-right: ${cssTheme.layout.spacing.s200};
`

// TODO: Remove getLinariaClassName when migrating to linaria
const FormButton = styled(InputButton)`
  &.--has-error {
    ${InputButtonStyledContainer} {
      border-color: ${cssTheme.colors.border.danger.primary};
    }

    ${StartIconsWrapper} svg {
      fill: ${cssTheme.colors.content.danger.secondary};
    }
  }
`

export const FakeDestinationInput = ({
  value,
  onClick,
  hasError = false
}: Props) => {
  const {formatMessage} = useIntl()

  return (
    <Wrapper>
      <FormButton
        size="lg"
        dataId="DestinationPickerTrigger"
        id="DestinationPickerTrigger"
        placeholder={formatMessage(
          destinationPickerMessages.destinationPlaceholder
        )}
        icon={<Icon colorPath="content.neutral.secondary" name="Pin" />}
        onClick={onClick}
        className={cx(hasError && '--has-error')}
      >
        {value && (
          <DestinationValue data-id="DestinationPickerTriggerValue" dir="auto">
            {value}
          </DestinationValue>
        )}
      </FormButton>
    </Wrapper>
  )
}
